import React, { useEffect, useState } from "react";
import { Row, Col, Button, FormGroup, Input } from "reactstrap";
import Cross from "../../../assets/images/verboden/cross.png";
import Player from "../../../assets/images/dw20/icons/player.jpg";
import Play from "../../../assets/images/verboden/play.png";
import Alert from "../../shared/common/alert";
import Minus from "../../../assets/images/dw20/icons/minus.png";
import Plus from "../../../assets/images/dw20/icons/plus.png";
import { removeUser } from "../../shared/utils";
import avatar from "../../../assets/images/avatar.svg";
import _ from "lodash";
import Socket from "../../../socket/socket";

import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../../socket/context";
import DWOption from "./dwOption";

const DWPlayers = (props) => {
  let roomData = props.gameReducer.roomObj;
  let users = props.gameReducer.roomObj.users;
  let gameObj = props?.paramsReducer?.gameObj?.screens?.lobby;
  const gameName = props.gameReducer.gameName;
  const [round, setRound] = useState(
    gameName && gameName !== "" && gameName === "DW20" ? 4 : 10
  );

  const [allUsers, setAllUsers] = useState([]);
  const comparer = (otherArray) => {
    return function (current) {
      return (
        otherArray.filter(function (other) {
          return other.player_id === current.player_id;
        }).length === 0
      );
    };
  };

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      score_to_win: round
    };
    Socket.sendMessage(data);
  }, [round]);

  useEffect(() => {
    let { gameReducer, usersChanged } = props;
    let roomObj = _.get(gameReducer, "roomObj");
    if (
      usersChanged &&
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length > 0
    ) {
      if (roomObj.users.length > allUsers.length) {
        let result = roomObj.users.filter(comparer(allUsers));
        playAudio(
          result && result[0].audio_effect ? result[0].audio_effect : ""
        );
        setAllUsers(roomObj.users);
      }
    }
    if (
      Object.keys(roomObj).length > 0 &&
      roomObj.users.length < allUsers.length
    ) {
      setAllUsers(roomObj.users);
    }
  }, [props.gameReducer.roomObj]);

  const playAudio = (url) => {
    var audio = document.createElement("audio");
    audio.src = url;
    audio.style.display = "none"; //added to fix ios issue
    audio.autoplay = true; //avoid the user has not interacted with your page issue
    audio.onended = function () {
      audio.remove(); //remove after playing to clean the Dom
    };
    document.body.appendChild(audio);
  };

  const onAddOrSubtractRound = (key) => {
    let currentRound = round;

    if (key === "add") {
      if (round >= 0) {
        if (currentRound >= 12) {
          Alert(200, "Max Score can be 12 only");
          return;
        } else {
          currentRound = parseInt(currentRound) + 1;
          setRound(currentRound);
        }
      }
    } else {
      if (round > 0) {
        currentRound = currentRound - 1;
        setRound(currentRound);
      }
    }
  };

  const handleChange = (e) => {
    setRound(e.target.value);
    return;
  };

  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };

  const imgError = (e) => {
    e.target.src = avatar;
  };
  return (
    <div className="dw20-players-wrapper">
      <div className="d-flex justify-content-between ">
        <h1 className="dw20-title text">
          {gameObj ? gameObj.players_label : "Players"}
        </h1>
        <p className="text">{users && users.length}/10</p>
      </div>
      <div className="dw20-players-list">
        {users &&
          users.length > 0 &&
          users.map((item) => {
            return (
              <div className="dw20-players-col">
                <div className="dw20-players-content">
                  <div className="profile-wrap">
                    <img
                      src={item ? item.profile_image : avatar}
                      onError={(e) => imgError(e)}
                      alt="profile"
                      className="profile"
                    />
                    <Button
                      color="themePink"
                      className="cross"
                      onClick={() => delPlayer(item)}
                    >
                      <img src={Cross} alt="cross" />
                    </Button>
                  </div>
                  <h3>{item.display_name}</h3>
                </div>
              </div>
            );
          })}
      </div>
      <DWOption />
      {/* <div className="d-flex justify-content-between align-items-end  pt-3">
        <div className="score-to-win">
          <div className="labelWrapper">
            <p>{gameObj ? gameObj.score_limit_label : 'Score to win'}</p>
          </div>

          <div className="inpWrapper">
            <div className="round">
              <div className="counter d-flex align-items-center">
                <Button color="themePurple" onClick={() => onAddOrSubtractRound("subtract")}>
                  <img src={Minus} alt="minus" />
                </Button>
                <FormGroup className="mx-3 mb-0">
                  <Input
                    min="1"
                    max="12"
                    type="number"
                    name="round"
                    onChange={(evt) => handleChange(evt)}
                    value={round}
                  />
                </FormGroup>
                <Button color="yellow" onClick={() => onAddOrSubtractRound("add")}>
                  <img src={Plus} alt="plus" />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="playBtn">
          <Button color="yellow" onClick={onStartGame}>
            <img src={Play} className="mr-3" />
            {gameObj ? gameObj.button_text : 'Start'}
          </Button>
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  loaderDetails: state.loaderDetails,
  paramsReducer: state.paramsReducer
});

export default compose(withSocket, connect(mapStateToProps, null))(DWPlayers);
